/** @format */

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { url } from "./api";
import { alertMsg } from "../utilities/helper";

const jwt = localStorage.getItem("jwt");

export const getOne = createAsyncThunk("item/getOne", async (obj, thunkApi) => {
  const { rejectWithValue } = thunkApi;

  try {
    const response = await axios({
      method: "GET",
      url: `${url + obj.path + obj.id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Accept-Language": "en",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });

    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});
export const getOneDetails = createAsyncThunk(
  "item/getOne",
  async (obj, thunkApi) => {
    const { rejectWithValue } = thunkApi;

    try {
      const response = await axios({
        method: "GET",
        url: `${url + obj.path + obj.id}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Accept-Language": "en",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getAll = createAsyncThunk("item/all", async (obj, thunkApi) => {
  const { rejectWithValue } = thunkApi;

  try {
    const response = await axios({
      method: "GET",
      url: `${url + obj.path}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });

    return response;
  } catch (err) {
    alertMsg("فشل تحميل البيانات  ", false);

    return rejectWithValue(err);
  }
});
export const delOne = createAsyncThunk("item/delete", async (obj, thunkApi) => {
  const { rejectWithValue } = thunkApi;

  try {
    const response = await axios({
      method: "DELETE",
      url: `${url + obj.path + obj.id}`,

      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Accept-Language": "en",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });
    alertMsg("تم الحذف  بنجاح", true);

    return response.data;
  } catch (err) {
    alertMsg("فشل الحذف  ", false);

    return rejectWithValue(err);
  }
});
